module.exports = __webpack_public_path__ + "img/water_tank_top.e96551fa.svg";